import React from "react"
import { Link } from "gatsby"
import mobileBackground from "../images/mobilebackground.png"
import Categorylinks from "../components/categorylinks"
import AnnouncementBar from "../components/announcement-bar"

import "../scss/navbar.scss"
import "../scss/contactForm.scss"
import "../scss/auditMenu.scss"

class Navbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      isOpen: false,
      auditActive: false,
      navBarActiveClass: "",
      auditMenuActiveClass: "",
    }
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({ navBarActiveClass: "is-active" })
          : this.setState({ navBarActiveClass: "" })
      }
    )
  }

  render() {
    return (
      <nav
        className={this.props.slug === "/" ? "navbar is-transparent" : "navbar"}
        role="navigation"
        aria-label="main-navigation"
      >
        <AnnouncementBar />
        <div className="container-max-width">
          <div className="container">
            <div className="navbar-brand">
              <Link
                to="/the-next"
                className="navbar-item navbar-item-logo"
                title="Logo"
              >
                <svg
                  width="147"
                  height="28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.15 1.8H.276v4.068h7.596V27h4.68V5.868h7.596V1.8zm8.11 15.156c0-2.628 1.728-4.392 4.176-4.392 2.7 0 3.852 1.872 3.852 4.428V27h4.536V16.236c0-4.464-2.412-7.632-6.732-7.632-2.772 0-4.86 1.224-5.832 3.348V.72h-4.536V27h4.536V16.956zm35.15 2.592v-1.476c0-5.544-3.78-9.468-9.431-9.468-5.544 0-9.468 3.96-9.468 9.396 0 5.364 3.564 9.432 9.684 9.432 4.284 0 7.74-2.484 8.964-5.688h-4.212c-.864 1.368-2.556 2.34-4.752 2.34-3.204 0-4.932-1.836-5.22-4.536H63.41zm-9.36-7.704c2.917 0 4.753 1.944 5.04 4.716H48.94c.36-2.916 2.304-4.716 5.112-4.716zM67.644 27h4.572V9.144L86.723 27h3.924V1.8h-4.572v17.892L71.567 1.8h-3.924V27zm46.111-7.452v-1.476c0-5.544-3.78-9.468-9.432-9.468-5.544 0-9.468 3.96-9.468 9.396 0 5.364 3.564 9.432 9.684 9.432 4.284 0 7.74-2.484 8.964-5.688h-4.212c-.864 1.368-2.556 2.34-4.752 2.34-3.204 0-4.932-1.836-5.22-4.536h14.436zm-9.36-7.704c2.916 0 4.752 1.944 5.04 4.716H99.282c.36-2.916 2.304-4.716 5.112-4.716zm19.797 2.7l-3.924-5.508h-4.752l6.336 8.928L115.335 27h4.788l4.068-5.616L128.295 27h4.788l-6.516-9.036 6.336-8.928h-4.752l-3.96 5.508zm13.436-5.508h-3.348v3.744h3.348v7.956c0 4.14 1.584 6.696 5.832 6.696 1.152 0 2.592-.252 3.168-.468v-3.636c-.612.18-1.224.324-1.98.324-1.764 0-2.484-.828-2.484-2.7V12.78h4.644V9.036h-4.644V3.672h-4.536v5.364z"
                    fill="#000"
                  />
                </svg>
              </Link>
              <button
                className={`navbar-burger burger ${this.state.navBarActiveClass}`}
                data-target="navMenu"
                label="Toggle Navigation"
                onClick={() => this.toggleHamburger()}
              >
                <span className="top" />
                <span className="middle" />
                <span className="bottom" />
              </button>
            </div>
            <div
              id="navMenu"
              style={{
                backgroundImage: `url(${mobileBackground})`,
                backgroundPosition: `center center`,
                backgroundSize: `100% 50%`,
                backgroundRepeat: `no-repeat`,
                backgroundAttachment: `fixed`,
              }}
              className={`navbar-menu ${this.state.navBarActiveClass}`}
            >
              <div className="navbar-items">
                <Categorylinks />
              </div>

              <div className="navbar-footer">
                <div className="links-bar">
                  <a className="phone-number" href="tel:1300191950">
                    1300 191 950
                  </a>
                </div>
                <div className="address">
                  <p>Level 7/22 Albert Rd, South Melbourne VIC 3205</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navbar
